var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},_vm._l((_vm.cells),function(cell){return _c('div',{key:cell.label,staticClass:"content"},[_c('div',[_vm._v(_vm._s(cell.label))]),_c('div',[_vm._v(_vm._s(_vm._f("valueFormatter")(cell.value)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }